// @ts-nocheck

import React, { useState, useEffect } from "react";
import { supabase } from "@/lib/supabase";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Calendar, Bell } from "lucide-react";
import { format } from "date-fns";

interface DashboardNotice {
  id: string;
  title: string;
  message_body: string;
  display_date: string;
  created_at: string;
}

const DashboardNotices: React.FC = () => {
  const [notices, setNotices] = useState<DashboardNotice[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchNotices();
  }, []);

  const fetchNotices = async () => {
    try {
      setIsLoading(true);
      const { data, error } = await supabase
        .from('dashboard_notices')
        .select('*')
        .eq('is_active', true)
        .order('display_date', { ascending: false })
        .limit(5); // Show only the 5 most recent notices

      if (error) {
        console.error('Error fetching notices:', error);
        return;
      }
      
      setNotices(data || []);
    } catch (error) {
      console.error('Exception when fetching notices:', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="bg-gradient-to-r from-blue-50 to-purple-50 p-6 rounded-lg shadow-sm mb-6 border border-gray-100">
        <div className="flex items-center space-x-2 mb-4">
          <Bell className="h-5 w-5 text-primary" />
          <h4 className="text-sm font-medium text-primary">Important Updates</h4>
        </div>
        <p className="text-center text-gray-500">Loading updates...</p>
      </div>
    );
  }

  if (notices.length === 0) {
    return null; // Don't show the section if there are no notices
  }

  return (
    <div className="bg-gradient-to-r from-blue-50 to-purple-50 p-6 rounded-lg shadow-sm mb-6 border border-gray-100">
      <div className="flex items-center space-x-2 mb-4">
        <Bell className="h-5 w-5 text-primary" />
        <h4 className="text-sm font-medium text-primary">Important Updates</h4>
      </div>
      
      <div className="space-y-4">
        {notices.map((notice) => (
          <div key={notice.id} className="bg-white bg-opacity-70 p-4 rounded-md">
            <div className="flex justify-between items-start mb-2">
              <h5 className="font-bold text-gray-800">{notice.title}</h5>
              <div className="flex items-center text-xs text-gray-500">
                <Calendar className="h-3 w-3 mr-1" />
                {format(new Date(notice.display_date), "MMM d, yyyy")}
              </div>
            </div>
            <p className="text-gray-700 whitespace-pre-wrap">{notice.message_body}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DashboardNotices;